import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { OperationsService } from 'src/app/core/services/operations.service';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import {
  ValoreEconomicoDataInteressiFormComponent
} from '../../../form/sez-economica/valore-economico-data-interessi-form.component';
import { CalcoloInteressiRequest } from '../../../models/calcolo-interessi-request';
import { Petitum } from '../../../models/petitum';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';

@Component({
  selector: 'div [sezione-economica-data-interessi-edit]',
  templateUrl: '../../../form/sez-economica/valore-economico-data-interessi-form.component.html',
})

export class SezioneEconomicaDataInteressiEditComponent extends ValoreEconomicoDataInteressiFormComponent implements OnInit {
  petitum: Petitum;
  calcolaInteressiRequest: CalcoloInteressiRequest;
  sezione: SezioneEconomica;
  urlUpdateDataInizioCalcolo: string;
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();

  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService) {
    super(operationService, campiForm, helpers);
  }

  ngOnInit() {
    // this.setTitle('Modifica dati - Data inizio calcolo interessi');
    this.isInserimento(false);
  }

  getPetitum() {
    return this.petitum;
  }

  getRequest(dataInizioCalcoloInteressi) {

    switch(this.tipoData){
      case 'sorte':
        this.operationService.updateDataInizioCalcoloPetitum(this.urlUpdateDataInizioCalcolo, {dataInizioCalcolo: dataInizioCalcoloInteressi, dataInizioCalcoloReset: dataInizioCalcoloInteressi ? false : true} , this.sezione.id).subscribe(response => this.datiResponse(response));
        break;
      case 'speselegali':
        this.operationService.updateDataInizioCalcoloPetitum(this.urlUpdateDataInizioCalcolo, {dataInizioCalcoloSpeseLegali: dataInizioCalcoloInteressi,dataInizioCalcoloSpeseLegaliReset: dataInizioCalcoloInteressi ? false : true} , this.sezione.id).subscribe(response => this.datiResponse(response));
        break;
      case 'danno':
        this.operationService.updateDataInizioCalcoloPetitum(this.urlUpdateDataInizioCalcolo, {dataInizioCalcoloMaggiorDanno: dataInizioCalcoloInteressi, dataInizioCalcoloMaggiorDannoReset: dataInizioCalcoloInteressi ? false : true} , this.sezione.id).subscribe(response => this.datiResponse(response));
        break;
      case 'rivalutazione':
        this.operationService.updateDataInizioCalcoloPetitum(this.urlUpdateDataInizioCalcolo, {dataInizioCalcoloRivalutazione: dataInizioCalcoloInteressi, dataInizioCalcoloRivalutazioneReset: dataInizioCalcoloInteressi ? false : true} , this.sezione.id).subscribe(response => this.datiResponse(response));
        break;
        default: break;
    }
  }

  datiResponse(response) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(sezione: SezioneEconomica, petitum: Petitum, urlUpdateDataInizioCalcolo: string, tipoData: string) {
    this.tipoData = tipoData;
    switch(tipoData) {
      case 'sorte':
        this.setTitle('Modifica dati - Data inizio calcolo interessi');
        break;
      case 'speselegali':
        this.setTitle('Modifica dati - Data inizio calcolo interessi spese legali');
        break;
      case 'danno':
        this.setTitle('Modifica dati - Data inizio calcolo maggior danno');
        break;
      case 'rivalutazione':
        this.setTitle('Modifica dati - Data inizio calcolo rivalutazione');
        break;
      default: break;
    }
    this.sezione = sezione;
    this.petitum = petitum;
    this.urlUpdateDataInizioCalcolo = urlUpdateDataInizioCalcolo;
    this.createForm();
    this.populateSelect();
  }

}
